exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-scroll[data-v-b8e93f06] {\n  max-height: 85px;\n  overflow: hidden;\n  transition: overflow 0.3s ease-in-out;\n  overflow-y: auto;\n}\n", ""]);

// exports
